import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import * as _ from "lodash";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IncidentsService } from "src/app/services/incidents/incidents.service";
import { AlarmaModel } from "../models/incidents-model";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "app-root",
  templateUrl: "./incidents-modal.component.html",
  styleUrls: ["./incidents-modal.component.scss"],
})
export class IncidentsModalComponent implements OnInit {
  displayedColumnsNotificationUserListAlarms: string[];
  dataSourceNotificationUserListAlarms: any;
  @ViewChild("paginator1", { static: true }) paginator1: MatPaginator;
  AlarmaForm: FormGroup;
  newAlarma: AlarmaModel = new AlarmaModel();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private incidentsService: IncidentsService
  ) {}

  ngOnInit() {
    this.doInitFormControls();
    if (this.data.option == -2) {
      if (this.data.users.length > 0) {
        this.displayedColumnsNotificationUserListAlarms = [
          "uuid",
          "usuario",
          "email",
        ];
        this.dataSourceNotificationUserListAlarms = new MatTableDataSource(
          this.data.users
        );
        this.dataSourceNotificationUserListAlarms.paginator = this.paginator1;
      }
    }
  }

  doInitFormControls() {
    this.AlarmaForm = this.fb.group({
      AlarmaNameControl: ["", Validators.required],
      AlarmaDescriptionControl: [""],
      AlarmaTypeControl: ["", Validators.required],
      AlarmaUsersControl: [""],
      AlarmaFieldControls: this.fb.array([]),
      AlarmaDependeControls: this.fb.array([]),
      AlarmaParametrosControls: this.fb.array([]),
      AlarmaTimeoutControl: [""],
    });
  }

  doAddAlarm() {
    console.log(
      "Add Alarma -> " + this.AlarmaForm.get("AlarmaNameControl").value
    );
  }

  doEditAlarm(type, id) {
    console.log("Do edit alarm of type -> " + type + " and ID -> " + id);
  }

  doRemoveAlarm(type, id) {
    console.log("Do edit alarm of type -> " + type + " and ID -> " + id);
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d;
    }
  }

  // Controles para el formulario
}
